
export const Home = () => {
  return (
    <h1>Welcome to the Back Office</h1>
  )
}
